import { Box, Typography } from '@mui/material';
import { Doughnut } from 'react-chartjs-2';

interface Props {
  engagements?: string;
  male?: string;
  female?: string;
}

const CardByGender: React.FC<Props> = ({ male, female, engagements }) => {
  const totalEngagements = Number(engagements) || 0;
  const maleEngagements = Number(male) || 0;
  const femaleEngagements = Number(female) || 0;

  let malePercent = 0;
  let femalePercent = 0;
  let otherPercent = 0;

  if (totalEngagements > 0) {
    malePercent = Math.round((maleEngagements / totalEngagements) * 100);
    femalePercent = Math.round((femaleEngagements / totalEngagements) * 100);
    otherPercent = Math.max(0, 100 - malePercent - femalePercent);
  }

  const legendItems = [
    { label: 'Male', value: malePercent, color: '#FF0050' },
    { label: 'Female', value: femalePercent, color: '#25CCC8' },
    { label: 'Other', value: otherPercent, color: '#9A9CA1' },
  ];

  const chartData = {
    datasets: [
      {
        data: [malePercent, femalePercent, otherPercent],
        backgroundColor: legendItems.map((item) => item.color),
        borderWidth: 0,
      },
    ],
  };

  const chartOptions = {
    cutout: '80%',
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
    },
    maintainAspectRatio: false,
  };

  return (
    <Box
      sx={{
        width: '100%',
        minWidth: '436px',
        minHeight: '191px',
        borderRadius: '20px',
        bgcolor: '#FFFFFF',
        // px: { xs: 3, md: 5 },
        pt: { xs: 3, md: 4 },
      }}
    >
      <Typography
        sx={{
          color: '#202124',
          textAlign: 'center',
          fontSize: { xs: '18px', md: '20px' },
          fontWeight: 400,
          lineHeight: 1.15,
          // mb: { xs: 3, md: 4 },
        }}
      >
        Engagement by Gender
      </Typography>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: { xs: 3, md: 6 },
          flexWrap: 'wrap',
        }}
      >
        <Box sx={{ position: 'relative', width: 140, height: 220, flexShrink: 0 }}>
          <Doughnut data={chartData} options={chartOptions} />
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography
              sx={{
                color: '#7B7B7B',
                fontSize: { xs: '18px', md: '20px' },
                fontWeight: 400,
                lineHeight: 1,
              }}
            >
              {totalEngagements}
            </Typography>
            <Typography
              sx={{
                color: '#202124',
                fontSize: { xs: '18px', md: '20px' },
                fontWeight: 400,
                lineHeight: 1,
                mt: 1,
              }}
            >
              Total
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2.5,
            minWidth: { xs: '100%', sm: 'auto' },
          }}
        >
          {legendItems.map((item) => (
            <Box key={item.label} sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <Box
                sx={{
                  width: 18,
                  height: 18,
                  borderRadius: '50%',
                  bgcolor: item.color,
                  flexShrink: 0,
                }}
              />
              <Typography
                sx={{
                  color: '#202124',
                  fontSize: { xs: '18px', md: '20px' },
                  fontWeight: 400,
                  lineHeight: 1.05,
                }}
              >
                {item.label}
              </Typography>
              <Typography
                sx={{
                  color: '#8A8A8A',
                  fontSize: { xs: '18px', md: '20px' },
                  fontWeight: 400,
                  lineHeight: 1.05,
                }}
              >
                -&nbsp;&nbsp;{item.value}%
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default CardByGender;
